/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 监管动态----最新动态
 */

import styles from './newest.scss';
import React, { PureComponent } from 'react';
import { Spin } from 'antd';
import {isNotEmpty} from '../../../../utils/util';
import NoData from '../../../common/noData/NoData';
import BBDWordCloud from '../../../common/echarts/BBDWordCloud';
import { formatStaWordOption } from '../common/formatEchartOption';
import SearchForm from './newest/SearchForm';
import ListModal from './newest/ListModal';
import { noticeList } from '../../../../services/regulatoryStatistical';

export default class Newest extends PureComponent {
    constructor(props) {
        super(props);
        this.wordEvents = {click: this.onComSelect};
        this.state = {
            searchParams: {},
            loading: true,
            wordOption: {},
            activeItem: {},
            visible: false
        };
    }

    onSearch = (params) => {
        this.setState({
            searchParams: params
        }, () => {
            this.getData();
        });
    };

    getData = () => {
        const { searchParams } = this.state;
        this.setState({
            loading: true
        });
        noticeList(searchParams).then(data => {
            data = data || [];
            this.setState({
                loading: false,
                wordOption: formatStaWordOption(data)
            });
        }).catch(() => {
            this.setState({
                loading: false,
                wordOption: {}
            });
        });
    };

    showModal = (activeItem) => {
        this.setState({ visible: true, activeItem });
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    onComSelect = (e) => {
        this.showModal(e.data);
    };

    render() {
        const { wordOption, loading, visible, activeItem, searchParams } = this.state;
        return (
            <div>
                <SearchForm onSearch={this.onSearch}/>

                <div className={styles.wordChart}>
                    {
                        loading ?
                            <Spin /> :
                            isNotEmpty(wordOption) ?
                                <BBDWordCloud option={wordOption} onEvents={this.wordEvents}/> :
                                <NoData />
                    }
                </div>
                <ListModal
                    searchParams={searchParams}
                    visible={visible}
                    item={activeItem}
                    onCancel={this.hideModal}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/state/Newest.jsx